
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit, Model } from "vue-property-decorator";
import { ModelListSelect } from "vue-search-select";
import VueSingleSelect from "vue-single-select";
@Component({
  components: {
    VueSingleSelect,
    ModelListSelect,
  },
})
export default class SelectAutocomplete extends Vue {
  @Model("input", { type: [String, Number] }) value!: string | number;
  @Prop() placeholder!: string;
  @Prop() list!: [];
  @Prop() required!: boolean;

  modValue: string | number | null = null;

  get computedValue() {
    if (this.value) {
      this.modValue = this.value;
    }
    return this.modValue;
  }
  @Emit()
  input() {
    return this.modValue ? this.modValue : "";
  }
}
